import { getDb } from '../LocalDB/LocalDB';
import { type Flight } from './Flight';

export async function getFlightsForAircraft(aircraftId: string): Promise<Flight[]> {
    return getDb().flights.where('aircraftId').equals(aircraftId).sortBy('createdAt');
}
